jQuery(document).ready(function () {
  $(".home-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    vertical: false,
    autoplay: true,
    autoplaySpeed: 2000,
  });

  jQuery(".bestseller-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  jQuery(".recomm-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  jQuery(".shopby-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: "unslick",
      },
    ],
  });
  // jQuery(".mattress-slider").slick({
  // 	dots: false,
  // 	arrows: false,
  // 	infinite: false,
  // 	slidesToShow: 4,
  // 	slidesToScroll: 1,
  // 	responsive: [
  // 		{
  // 			breakpoint: 1399,
  // 			settings: {
  // 			  slidesToShow: 3,
  // 			}
  // 		},
  // 		{
  // 		  breakpoint: 991,
  // 		  settings: {
  // 			slidesToShow: 2,
  // 			dots: true,
  // 		  }
  // 		},
  // 		{
  // 			breakpoint: 767,
  // 			settings: {
  // 			  slidesToShow: 1,
  // 			  dots: true,
  // 			}
  // 		}
  // 	]
  // });
  jQuery(".voice-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  jQuery(".blog-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: true,
        },
      },
    ],
  });
  jQuery(".review-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  jQuery(".store-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: "unslick",
      },
    ],
  });
  jQuery(".ask-card").click(function () {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
    } else {
      jQuery(".ask-card").removeClass("active");
      jQuery(this).addClass("active");
    }
  });
  jQuery(".bestseller-tab li a").on("click", function () {
    var target = jQuery(this).attr("data-rel");
    jQuery(".bestseller-tab li a").removeClass("active");
    jQuery(this).addClass("active");
    jQuery("#" + target)
      .fadeIn("slow")
      .siblings(".bestseller-main")
      .hide();
    jQuery(".bestseller-slider").slick("setPosition");
    return false;
  });
  jQuery(".product-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    asNavFor: ".product-nav-slider",
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  jQuery(".product-nav-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: false,
    asNavFor: ".product-slider",
    dots: false,
    arrows: false,
    infinite: false,
    vertical: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 479,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
  jQuery(".account-left-top").click(function () {
    jQuery(".account-left").toggleClass("accountactive");
  });
  if (window.matchMedia("(min-width: 768px)").matches) {
  }
  if (window.matchMedia("(max-width: 1399px)").matches) {
  }
  if (window.matchMedia("(max-width: 1199px)").matches) {
    jQuery(".nav-item .arrow").click(function () {
      jQuery(this)
        .parent(".nav-item")
        .toggleClass("active")
        .siblings()
        .removeClass("active");
    });
    jQuery(".sidebar-togle-wraper").click(function () {
      jQuery(".layer-bg").toggleClass("active");
      jQuery(".header").toggleClass("active");
      jQuery("body").toggleClass("overflow-hiiden");
    });
    jQuery(".search-icon").click(function () {
      jQuery(".header-search").addClass("active");
      jQuery(".header").removeClass("active");
    });
    jQuery(".search-box .close").click(function () {
      jQuery(".header-search").removeClass("active");
    });
  }
  if (window.matchMedia("(max-width: 991px)").matches) {
    // jQuery('.virtual-tab li a').on('click', function(){
    // 	var target = jQuery(this).attr('data-rel');
    //  jQuery('.virtual-tab li a').removeClass('active');
    // 	jQuery(this).addClass('active');
    // 	jQuery("#"+target).fadeIn('slow').siblings(".virtual-tab-box").hide();
    // 	jQuery('.virtual-tab-box').slick('setPosition');
    // 	return false;
    // });
    jQuery(".still-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: "unslick",
        },
      ],
    });
    jQuery(".moment-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: true,
          },
        },
      ],
    });

    jQuery(".f-colm .kurlonxsheading").click(function () {
      if (jQuery(this).hasClass("in")) {
        jQuery(this).removeClass("in");
        jQuery(this).siblings(".ftr-content").slideUp();
      } else {
        jQuery(".f-colm .kurlonxsheading").removeClass("in");
        jQuery(".ftr-content").slideUp();
        jQuery(this).addClass("in");
        jQuery(this).siblings(".ftr-content").slideDown();
      }
    });
  }
});

$(document).ready(function () {
  jQuery(".journey-slider").slick({
    dots: false,
    arrows: false,
    // centerMode: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  });
  jQuery(".innovation-slider").slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    loop: true,
    vertical: true,
    asNavFor: ".innovation-nav",
  });
  jQuery(".innovation-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: false,
    asNavFor: ".innovation-slider",
    dots: false,
    arrows: false,
    infinite: true,
    loop: true,
    vertical: true,
    focusOnSelect: true,
  });
  jQuery(".awards-slider").slick({
    dots: false,
    arrows: false,
    centerMode: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".lifeat-slider").slick({
    dots: false,
    arrows: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
        },
      },
    ],
  });
  $(".meet-slider").slick({
    dots: false,
    arrows: true,
    variableWidth: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          variableWidth: false,
          slidesToShow: 1,
        },
      },
    ],
  });
  if (window.matchMedia("(max-width: 767px)").matches) {
    $(".ourvalue-right").slick({
      dots: true,
      arrows: false,
      // autoplay: true,
      // autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  jQuery(".release-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  });
  // jQuery(".media-slider").slick({
  //   dots: true,
  //   arrows: true,
  //   infinite: false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 3,
  //       },
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         dots: true,
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // });
});

// $(".tab-menu-list_investor li a").on("click", function () {
//   var target = $(this).attr("data-rel");
//   $(".tab-menu-list_investor li a").removeClass("active");
//   $(this).addClass("active");
//   $("#" + target)
//     .fadeIn("slow")
//     .siblings(".tab-output-box_investor")
//     .hide();
//   return false;
// });

$(".mobile-dropdowen_investor").click(function () {
  $(".tab-menu-list_investor").toggleClass("active");
});

$(".tab_link_inner").click(function () {
  // Get the text from the source (button)
  var textToPaste = $(this).text();

  // Paste the text into the target div
  $(".select_investor_text").text(textToPaste);
  $(".tab-menu-list_investor").removeClass("active");
});

document.addEventListener("DOMContentLoaded", function () {
  const caseTabLinks = document.querySelectorAll(".tab-link");
  const caseCards = document.querySelectorAll(".tab-output-box_investor");

  if (caseTabLinks) {
    caseTabLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        const targetId = this.getAttribute("id");
        caseCards.forEach(function (card) {
          const cardTarget = card.getAttribute("data-case-target");
          if (targetId == "all-pdf") {
            card.classList.add("show");
            // console.log(card);
          } else if (cardTarget == targetId) {
            card.classList.add("show");
          } else {
            card.classList.remove("show");
          }
        });

        caseTabLinks.forEach(function (link) {
          link.classList.remove("active");
        });

        this.classList.add("active");
      });
    });
  }
});




var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "SAR{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', function () {
  
});
function outputDimensions(size){
  var variantMaster = window.variantMaster;
  if(variantMaster[size]){
    //var options = '<option value="">-- Select --</option>';
    var options = '';
    var values = [];
    variantMaster[size].forEach(function(v){
      
      if(!values.includes(v?.option3?.toLowerCase())){
        options += `<option value="${v.option3}">${v.option3}</option>`;  
      }
      values.push(v?.option3?.toLowerCase());
      
    })
    
    document.querySelector('[name="option3"]').innerHTML = options;
  }
}

function changeVariantValues(e,handle){
  
  const selectedInputs = Array.from(document.querySelectorAll('#variant-selectors label')).map(fieldset => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  });
  selectedInputs.forEach(function(value){
    var lowerVal = value?.toLowerCase();
    if(lowerVal == 'single' || lowerVal == 'twin' || lowerVal == 'king' || lowerVal == 'queen' || lowerVal == 'super king'){
      outputDimensions(value);
    }
  })
  
  changeVariant(e,handle);
}
function changeVariant(e,handle){

  
  var customLength = document.querySelector(customLengthElement);
  var customBreadth = document.querySelector(customBreadthElement);
  var customThickness = document.querySelector(customThicknessElement);
  
  customLength.value = '';
  customBreadth.value = '';
  customThickness.innerHTML = '';
  
  document.querySelectorAll(hideElements).forEach(function(e){
    e.classList.remove('hide');
    e.classList.add('display');
  });
  document.querySelectorAll(displayElements).forEach(function(e){
    e.classList.remove('display');
    e.classList.add('hide');
  });
  
  var productVariants = window.productVariants;
  var selectors = document.querySelectorAll('#variant-selectors select');
  var inputs = document.querySelectorAll('#variant-selectors input[type="radio"]');
  
  document.querySelector('.custom-size').classList.remove('active')
  const selectedInputs = Array.from(document.querySelectorAll('#variant-selectors label')).map(fieldset => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  });
  
  const selectedOptions = Array.from(document.querySelectorAll('#variant-selectors #dimensions-dropdown select')).map(select => {
    return select.value;
  });
  var options = [];
  selectedInputs.forEach(function(value){
    if(value){
      options.push(value)
    }
  });
  options.push(selectedOptions[0]);
  
  function findVariant(options) {
    options = options.join(' / ');
    var selected = '';
    console.log('incoming options:',options)
    for(i=0; i < productVariants.length; i++){
      var variant = productVariants[i];
      if(options == variant.public_title){
        selected = variant;
        break;
      }
    }
    return selected;
  }
  
  var finalVariant = findVariant(options);
  var price = Shopify.formatMoney(finalVariant.price,"SAR. {{amount}}"), off = '';
  if(finalVariant){
    if(finalVariant.compare_at_price){
      price += `<span>${Shopify.formatMoney(finalVariant.compare_at_price,"SAR. {{amount}}")}</span>`;
      off = calculatePercentageOff(finalVariant.compare_at_price / 100, finalVariant.price / 100);
    }
    document.querySelector('#PdpPercentageOff').innerHTML = off;
    document.querySelector('#pdpPrice').innerHTML = price;  
  }else{
    
  }
  
  console.log(finalVariant.price)
  console.log(selectedInputs);
  document.querySelectorAll('.variantSelector').forEach(function(element){
    element.classList.remove('active')
  })
  inputs.forEach(function(element){
    if(element.checked === true){
      var parent = element.parentElement
      parent.classList.add('active')
    }
    
  });

// Store the old price before switching variants
let oldPrice = document.querySelector('#pdpPrice') ? document.querySelector('#pdpPrice').innerHTML : '';

if (finalVariant) {
    document.querySelector('#pdp-main-variant').value = finalVariant.id;
    document.querySelector('#pdpVariantTitle').innerHTML = finalVariant.public_title.replace(/\//g, ',');
    history.pushState({}, '', `/products/${handle}?variant=${finalVariant.id}`);

    let pdpPrice = document.querySelector('#pdpPrice');
    let inclusiveTax = document.querySelector('.inclusive-tax'); // VAT div
    let toCartButton = document.querySelector('.anchor-bg-btn'); // Add to Cart button
    let toCartText = document.querySelector('#toCart'); // Button text
    let shopNowButton = document.querySelector('#shopnw'); // Additional button

    if (pdpPrice) {
        // Remove 'out-of-stock' class when variant is available
        pdpPrice.classList.remove('out-of-stock');

        // Keep the old price instead of changing it
        pdpPrice.innerHTML = oldPrice;

        // Show inclusive-tax div when product is in stock
        if (inclusiveTax) {
            inclusiveTax.style.display = 'block';
        }

        // Enable Add to Cart button and change text back to "Add To Cart"
        if (toCartButton) {
            toCartButton.removeAttribute('disabled');
        }
        if (toCartText) {
            toCartText.innerHTML = "Add To Cart";
        }

        // Show "Shop Now" button when in stock
        if (shopNowButton) {
            shopNowButton.style.display = 'block';
        }
    }
} else {
    document.querySelector('#pdp-main-variant').value = '';
    document.querySelector('#pdpVariantTitle').innerHTML = '';
    document.querySelector('#PdpPercentageOff').innerHTML = '';

    let pdpPrice = document.querySelector('#pdpPrice');
    let inclusiveTax = document.querySelector('.inclusive-tax'); // VAT div
    let toCartButton = document.querySelector('.anchor-bg-btn'); // Add to Cart button
    let toCartText = document.querySelector('#toCart'); // Button text
    let shopNowButton = document.querySelector('#shopnw'); // Additional button

    if (pdpPrice) {
        // Display "Out of Stock" and maintain the old price
        pdpPrice.innerHTML = 'Out of Stock';
        pdpPrice.classList.add('out-of-stock');
    }

    // Hide inclusive-tax div when product is out of stock
    if (inclusiveTax) {
        inclusiveTax.style.display = 'none';
    }

    // Disable Add to Cart button and change text to "Out of Stock"
    if (toCartButton) {
        toCartButton.setAttribute('disabled', 'disabled');
    }
    if (toCartText) {
        toCartText.innerHTML = "Out of Stock";
    }

    // Hide "Shop Now" button when out of stock
    if (shopNowButton) {
        shopNowButton.style.display = 'none';
    }
}


  
}
function calculatePercentageOff(mrp, salePrice) {
  if (mrp <= 0) {
    return '';
  }
  const percentageOff = ((mrp - salePrice) / mrp) * 100;
  if(percentageOff > 0){
    return percentageOff.toFixed(0) + '% off'; // Returns the result rounded to 2 decimal places  
  }
}
var header = document.querySelector(".header");
var navbarHeight = header.offsetHeight;
var lastScrollTop = 0;

window.onscroll = function() {scrollHide()};

function scrollHide() {
  var st = window.pageYOffset || document.documentElement.scrollTop;
  console.log(st);
  if (st > lastScrollTop) {
    header.classList.add('hide');
  } else {
    header.classList.remove('hide');
  }
  lastScrollTop = st <= 0 ? 0 : st;
}

